import { createApp } from 'vue';
import LottieToWebpConverter from '@/Components/LottieToWebpConverter.vue';
import '@styles/app.css';

createApp(LottieToWebpConverter).mount('#lottie-to-webp-converter');
